/**
 * @param MessageEvent e
 */
function receiveMessage(e) {
  // if (e.data) {
  //     // console.error('receiveMessage', e);
  // }
  if (e.data == 'qcmQuit') {
    quitQcm();
  }
}

// https://developer.mozilla.org/fr/docs/Web/API/Window/postMessage
// window.parent.postMessage('qcmQuit',"*");
window.addEventListener("message", receiveMessage, false);

// Message from parent window (iframe)
window.quitQcm = () => {
  /*
  2020-09-15 Debug. Display swich portrait/landscape corrupted w iphone.
  return false;
  */

  var isCustomerArea = RegExp('/u/c/').test(window.location.href);
  if (!isCustomerArea) {
    return null;
  }

  if (true || $('body').hasClass('body-with-qcm')) {
    console.log('[QCM] quit', arguments);

    /*
    // TypeError: window.gtag is not a function
    window.gtag('event', 'qcm', {
        'event_category': 'close',
        'event_label': window.location.hash
    });
    */

    $('body').removeClass('body-with-qcm');

    if (arguments.length && arguments[0] == 'menu') {
      return false;
    }

    $('body').removeClass('registration');
    $('body').css('overflow', 'auto');
    $('.mcq-modal-histo').hide();

    let isAlreadyStatsPage = RegExp('/u/c/[0-9]+-stat.*').test(window.location.href);
    if (isAlreadyStatsPage) {
      return null;
    }

    let win = window.parent;
    let isNotParent = RegExp('^#/qcm/').test(window.location.hash);
    if (isNotParent || !win) {
      win = window;
    }
    let isHash = RegExp('^#/qcm/').test(win.location.hash);
    let isLaunch = !win.length;
    if (isHash || window.history.length > 1) {
      if (window.history.length > 1) {
        window.history.go(-1);
      } else {
        window.location.href = '#nohist';
      }
    } else if (isLaunch) {
      window.opener = window;
      window.close();
    }
  } else {
    console.log('[QCM] already closed');
    // Just is case... @see /u/c/23-statistiques
    $('.mcq-modal-histo').hide();
    $('body').css('overflow', 'auto');
  }
}

window.openQcm = (() => {

  console.log('[QCM] open', arguments);
  // window.scrollTo('body', 0);

  // Doc PDF de Xavier
  var daQcm = document.getElementById('idFrameDuQcm');
  if (daQcm && daQcm.contentWindow) {
    window.addEventListener("keydown", daQcm.contentWindow.onQcmKeyEvent);
  }

  $('body').addClass('body-with-qcm');
  $('body').css('overflow', 'hidden');

  if (/free/.test(window.location.hash)) {
    $('body').addClass('registration');
    $('html, body').scrollTop(0);
  }

  // TypeError: window.gtag is not a function
  // window.gtag('event', 'qcm', {
  //     'event_category': 'open',
  //     'event_label': window.location.hash
  // });

  $('.body-with-qcm').find('.navbar').find('a[href]').click(e => {
    // Navbar btns
    quitQcm('menu');
  });
  $('.body-with-qcm').find('.navbar').find('a[onclick]').on('click', (e) => {
    // Logout btn
    quitQcm('menu');
  });
});